module.exports = __webpack_public_path__ + "static/media/arrow-down.8e99d4fe.svg";